import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { DeleteDialog } from 'common/components/deleteDialog/DeleteDialog';
import { DeleteDialogCustomField } from 'common/components/deleteDialog/DeleteDialogCustomField';
import { selectPageInfo, setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { useDeleteDialogHandler } from 'common/hooks/useDeleteDialogHandler';
import { deleteUserGroupsUserMembershipList } from 'common/services/api/UserGroupUserMembership/UserGroupUserMembership.thunk';
import { DeleteDialogContentProps } from 'common/types/TypeDefs';

export function UserGroupUserMembershipDeleteDialog({
    customDeleteTitle,
    itemId,
    editingRow
}: Readonly<DeleteDialogContentProps<{ name: string, userGroupId: string, userId: string }>>) {
    const dispatch = useAppDispatch();
    const pageInfo = useAppSelector(selectPageInfo);
    const { userGroupId, name, userId } = editingRow ?? {};
    const userFirstName = pageInfo?.firstName ?? 'Unknown';
    const userLastName = pageInfo?.lastName ?? 'User';
    const { tenantId } = useParams();

    const { processing, handleDelete } = useDeleteDialogHandler({
        deleteThunk: deleteUserGroupsUserMembershipList,
        entityName: 'User Group link',
        successMessage: 'User Group link has been deleted.',
        onSuccess: (result) => {
            dispatch(setRows(result.formattedData));
        },
    });

    const deleteCallback = () => {
        if (itemId) {
            handleDelete({
                tenantId: tenantId ?? '',
                userId: userId ?? '',
                userGroupId: userGroupId ?? ''
            });
        }
    };

    return (
        <DeleteDialog deleteCallback={deleteCallback} processing={processing} customDeleteTitle={`${customDeleteTitle}`}>
            <DeleteDialogCustomField fieldName='User' fieldValue={`${userFirstName} ${userLastName}`}/>
            <DeleteDialogCustomField fieldName='User Group Name' fieldValue={name}/>
            <DeleteDialogCustomField fieldName='Tenant Name' fieldValue={pageInfo?.name ?? ''}/>
        </DeleteDialog>
    );
}
